module.exports = new __parcel__URL__("shop_machines_star_laboratory_v2.36359ee4.png").toString();